/**
 * A wall's top is a floor for the storey above it. A body that jumps up onto a wall, or comes down on
 * one from above, stands there on this item: laid in the storey's floor layer, walkable like any floor,
 * drawn by nothing (its tile is an empty cell flagged `hidden`, floors.tsx), and replaced by a real
 * floor built on the cell as if the cell were bare. (No imports: the HouseBuilder reads it.)
 */
export const WALL_TOP_FLOOR = "floor-wall-top"
/** The floors-sheet cell the HouseBuilder prints for it. */
export const WALL_TOP_FLOOR_TILE = 1023

/** Whether `itemType` is the wall-top floor, which a built floor treats as no floor at all. */
export const isWallTopFloor = (itemType: string | undefined): boolean => itemType === WALL_TOP_FLOOR
